/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_View_MapInputs */

const vi_grower_area_view_map = /** @type {(inputs: Grower_Area_View_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản đồ`)
};

/**

* @param {Grower_Area_View_MapInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_view_map = /** @type {((inputs?: Grower_Area_View_MapInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_View_MapInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_view_map(inputs)
});